
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { API_ROUTES } from "@/utils/API";
import { WARNING_POPUP_TYPE } from "@/constants/popupTypes";
import { API_TPrepaidServicesDetails } from "@/models/prepaid_services_details";

@Component
export default class ManageSubscriptionPopup extends Vue {
  @Prop({ type: Boolean, default: false }) readonly show!: boolean;
  @Prop({ type: String, default: WARNING_POPUP_TYPE }) readonly type!: string;

  showPopup = false;

  @Watch("show", { immediate: true })
  showPopupChanged(val: boolean) {
    this.showPopup = val;
  }

  open() {
    this.showPopup = true;
  }

  close() {
    this.showPopup = false;

    this.$emit("close");
  }

  options = [
    { value: true, label: "Yes" },
    { value: false, label: "No" },
  ];

  form: API_TPrepaidServicesDetails = {
    sponsor_licence: false,
    cos_skilled_worker: 0,
  };

  loading = false;

  get companyId(): number {
    return Number(this.$route.params.company_id ?? 0);
  }

  setFormData(data: API_TPrepaidServicesDetails) {
    this.form.sponsor_licence = Boolean(data.sponsor_licence) || false;
    this.form.cos_skilled_worker = Number(data.cos_skilled_worker) || 0;
  }

  async fetchSubscriptionDetails() {
    if (!this.companyId) return;

    try {
      const { data } = await this.axios.get(
        API_ROUTES.EXPERT_COMPANY_PREPAID_SERVICES(this.companyId)
      );

      if (!data) return;

      this.setFormData(data);
    } finally {
      this.loading = false;
    }
  }

  async saveSubscriptionDetails() {
    if (!this.companyId) return;

    try {
      this.setFormData(this.form);

      await this.axios.put(API_ROUTES.EXPERT_COMPANY_PREPAID_SERVICES(this.companyId), this.form);

      this.close();
    } finally {
      this.loading = false;
    }
  }

  async mounted() {
    await this.fetchSubscriptionDetails();
  }

  get isDisabled() {
    return false;
  }
}
